import { z } from 'zod';
import { LegalEntity, LegalEntitySchema } from '@/types/legal-entity.type.ts';
import { DealerStatus } from '@/types/dealer/dealer-status.type.ts';

export type Dealer = {
    id: number,
    holding_id: number | null,
    sap_code: string,
    city_id: number,
    name: string,
    is_certified: boolean,
    is_hyundai_dealer: boolean,
    is_genesis_dealer: boolean,
    phone: string | null,
    email: string | null,
    site: string | null,
    status: DealerStatus,
    legal_entity: LegalEntity | null,
    holding_name: string | null,
    city_name: string | null,
};

export const DealerSchema = z.object({
    id: z.number(),
    holding_id: z.number().nullable(),
    sap_code: z.string(),
    city_id: z.number(),
    name: z.string(),
    is_certified: z.boolean(),
    is_hyundai_dealer: z.boolean(),
    is_genesis_dealer: z.boolean(),
    phone: z.string().nullable(),
    email: z.string().nullable(),
    site: z.string().nullable(),
    status: z.nativeEnum(DealerStatus),
    legal_entity: LegalEntitySchema,
    holding_name: z.string().nullable(),
    city_name: z.string().nullable(),
});
